"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var OrderContext = (0, _react.createContext)({});
var _default = OrderContext;
exports.default = _default;